__turbopack_context__.v({
  "actionButton": "tenant17g5Styles-module-scss-module__oCsBFa__actionButton",
  "description": "tenant17g5Styles-module-scss-module__oCsBFa__description",
  "intro": "tenant17g5Styles-module-scss-module__oCsBFa__intro",
  "lgContainer": "tenant17g5Styles-module-scss-module__oCsBFa__lgContainer",
  "mdContainer": "tenant17g5Styles-module-scss-module__oCsBFa__mdContainer",
  "narrowContainer": "tenant17g5Styles-module-scss-module__oCsBFa__narrowContainer",
  "pageContainer": "tenant17g5Styles-module-scss-module__oCsBFa__pageContainer",
  "secondaryBtn": "tenant17g5Styles-module-scss-module__oCsBFa__secondaryBtn",
  "sectionDescription": "tenant17g5Styles-module-scss-module__oCsBFa__sectionDescription",
  "sectionTitle": "tenant17g5Styles-module-scss-module__oCsBFa__sectionTitle",
  "titlePattern": "tenant17g5Styles-module-scss-module__oCsBFa__titlePattern",
});
